import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { unboxLabel } from '../Configurations';
import { ConfigurationSelect } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const SystemConfigurationInput = () => (
  <ConfigurationSelect configurationKey="system" dispatchAction="SET_SYSTEM" />
);

const config: ConfigurationComponent<'system'> = {
  key: 'system',
  input: <SystemConfigurationInput />,
  display: (value: ConfigurationValues['system']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
